module.exports = __webpack_public_path__ + "static/media/research-deceptively-icon.39502243.png";